export default __webpack_public_path__ + "static/main_bg-b6ebda58f174349d064ed4e96978ae95.svg";